exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-7271a9ca]{\n    background: #000;\n    height: 100vh;\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\nvideo[data-v-7271a9ca]{\n    width: 80%;\n    height: 90%;\n}\n.back[data-v-7271a9ca]{\n  color: #fff;\n  position: absolute;\n  width: 100px;\n  height: 30px;\n  left: 20px;\n  top: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7271a9ca","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/video.vue
// module id = YK+6
// module chunks = 1